import type { OnboardingStep } from "@/api/onboarding";

export function shouldSuppressNonOnboardingPermissions({
  step,
  reconnecting,
}: {
  step: OnboardingStep | null;
  reconnecting: boolean;
}): boolean {
  if (reconnecting) return false;
  return step !== null && step !== "completed" && step !== "skipped";
}
